import { render, staticRenderFns } from "./HomeNavigationButtons.vue?vue&type=template&id=bc5107c2&scoped=true"
import script from "./HomeNavigationButtons.vue?vue&type=script&lang=js"
export * from "./HomeNavigationButtons.vue?vue&type=script&lang=js"
import style0 from "./HomeNavigationButtons.vue?vue&type=style&index=0&id=bc5107c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5107c2",
  null
  
)

export default component.exports